import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const AvvBalanceWrapper = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
`;

export const AvvBalanceFlex = styled.div`
  justify-content: space-between;
  display: flex;
  text-align: center;
  line-height: 24px;

  &:not(:last-of-type) {
    margin-bottom: 12px;
  }
`;

export const AvvBalance = styled.p`
  display: flex;
  align-items: center;
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.regular')};
  color: #888;
`;

export const AvvBalanceMount = styled.p`
  display: flex;
  align-items: center;
  margin: 0;
  font-size: ${themeGet('fontSizes.sm')}px;
  font-weight: ${themeGet('fontWeights.semiBold')};
  color: ${themeGet('colors.primary.extra')};
`;
